module.exports = __webpack_public_path__ + "static/media/class_job_028.cb2a00e1.svg";